import React, { useCallback, useState, useEffect } from 'react'
import { store } from "@root/store/index";
import { Select, Form, Button, Table, Input, Pagination, message } from 'antd';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { getHelpRelation, setConfirm, getHospitalBatch } from "@root/common/service";
import type { ColumnsType } from 'antd/es/table';
// import "./_style.scss"

const { Option } = Select;
interface DataType {
  key: number|string;
  auditStatus: number|string; // 国家审核状态 0审核通过  1- 2待审核
  confirmStatus: number|string; // 支援医院确认状态 0通过 1拒绝 2未确认 
  adjustType: string; // 调整类型 0新增帮扶 1解除帮扶
  year: number|string; // 年度
  batchNumber: number|string;  // 批次
  recipientProvince: string;  // 受援医院省份
  recipientInstituteProvince: string|number;  //受援医院省份
  recipientInstituteName: string;  // 受援医院名称
  subject: string;  // 学科
  subjectId: number|string;  // 学科
  supportProvince: string;  // 支援医院省份
  supportInstituteName: string;  // 支援医院名称
  supportInstituteProvince: string|number;
  fileUrl: string;
}

function Index() {

  const columns: ColumnsType<DataType> = [
    {
      title: '国家审核状态',
      dataIndex: 'auditStatus',
      key: 'auditStatus',
      width: 60,
      render: (_, a) => (
        <>
        {(()=>{
          if(a.confirmStatus === '1'){
            return ( <span style={{color: '#ff5733'}}>-</span> )
          }else if(a.auditStatus === '2'){
            return ( <span style={{color: '#ff8d1a'}}>待审核</span> )
          }else if(a.auditStatus === '1'){
            return ( <span style={{color: 'red'}}>审核退回</span> )
          }else if(a.auditStatus === '0'){
            return ( <span style={{color: '#43cf7c'}}>审核通过</span> )
          }
        })()}
        </>
      ),
    },
    {
      title: '确认状态',
      dataIndex: 'confirmStatus',
      key: 'confirmStatus',
      width: 60,
      render: (_, a) => (
        <>
        {(()=>{
          if(a.confirmStatus === '0'){
            return ( <span style={{color: '#2a82e4'}}>通过</span> )
          }else if(a.confirmStatus === '2'){
            return ( <span style={{color: '#ff8d1a'}}>未确认</span> )
          }else{
            return ( <span style={{color: '#ff5733'}}>拒绝</span> )
          }
        })()}
        </>
      ),
    },
    {
      title: '调整类型',
      dataIndex: 'adjustType',
      key: 'adjustType',
      width: 80,
      render: (_, a) => (
        <>
        {(()=>{ 
          if(a.adjustType === '0'){
            return ( <span style={{color: '#fff', backgroundColor: '#2a82e4', padding: '3px', borderRadius: '11px'}}>新增帮扶</span> )
          }else{
            return ( <span style={{color: '#fff', backgroundColor: '#ff8d1a', padding: '3px', borderRadius: '11px'}}>解除帮扶</span> )
          }
        })()}
        </>
      ),
    },
    {
      title: '年度',
      dataIndex: 'year',
      key: 'year',
      width: 50,
    },
    {
      title: '批次',
      dataIndex: 'batchNumber',
      key: 'batchNumber',
      width: 30,
    },
    {
      title: '受援医院省份',
      dataIndex: 'recipientProvince',
      key: 'recipientProvince',
      width: 60,
      render: (_, a) => (
        <>
        {(()=>{ 
          let recipientProvince: any = ''
          provinceArr.forEach((e: any)=>{
            if(a.recipientInstituteProvince === e.value){
              recipientProvince = e.label            
            }
          })
          return (<span>{recipientProvince}</span>)
        })()}
        </>
      ),
    },
    {
      title: '受援医院名称',
      dataIndex: 'recipientInstituteName',
      key: 'recipientInstituteName',      
    },
    {
      title: '帮扶学科',
      dataIndex: 'subject',
      key: 'subject',
      width: 100,
      render: (_, a) => (
        <>
        {(()=>{ 
          let subject: any = ''
          subjectIdArr.forEach((e: any)=>{
            if(a.subjectId === parseFloat(e.id)){
              subject = e.name
              return
            }
          })
          return (<span>{subject}</span>)
        })()}
        </>
      ),
    },
    {
      title: '操作',
      dataIndex: 'set',
      key: 'set',
      width: 50,
      render: (_,e)=> (<Button style={{padding: '0'}} onClick={()=>download(e)} type="link" disabled={!e.fileUrl}>下载附件</Button>),
    },
  ];
  
  // const data: DataType[] 
  

  const [form1] = Form.useForm();
  const [data, setData] = useState<DataType[]>();
  const [nowYear, setNowYear] = useState<number>()
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState<number>()
  const [searchValue, seetSearchValue] = useState<any>([])
  const [provinceArr, setProvinceArr] = useState<any>([])
  const [subjectIdArr, setSubjectIdArr] = useState<any>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [batch, setBatch] = useState<number>()

  const getBatch = async()=>{
    const {data: a} = await getHospitalBatch({
      instituteId: store.getState().userInfo.instituteId
    })
    setBatch(a.batchNumber)
    setNowYear(a.year)
  }

  const getAll = useCallback(async(e:number)=>{
    const keys: Array<string> = Object.keys(searchValue)
    const values = Object.values(searchValue)
    const arr: any = values.reduce(function(r,el,i){
      if(!!el){
        r+=`${keys[i]}=${el}&`
      }
      return r
    },'')
    console.log(arr); 
    const {rows,total} = await getHelpRelation(`${arr}pageNum=${1}&pageSize=100000&type=0`);
    rows.forEach((el: any) => {
      el.key = el.id
      if(!!el.fileUrl){
        console.log(el);
        
      }
    });
    setData(rows)
    setTotal(total)
  },[searchValue])
    
  useEffect(()=>{
    console.log(store.getState());
    const date = new Date()
    setNowYear(date.getFullYear())
    setProvinceArr(store.getState().directionaries.chinaProvinceData)
    setSubjectIdArr(store.getState().directionaries.subjectData)
    seetSearchValue({})
    getBatch()
    getAll(1)
  },[])

  const download = useCallback((e: any)=>{
    console.log(e);
    window.location.href = e.fileUrl
  },[])
  const onChange = useCallback((e: any)=>{
    console.log(e);
    setCurrent(e)
    getAll(e)
  },[getAll])
  const handleChange = useCallback((e: any)=>{
    console.log(e);
  },[])
  const onFinish = useCallback((e: any)=>{
    console.log(e);
    seetSearchValue(e)
    const keys: Array<string> = Object.keys(e)
    const values = Object.values(e)
    const arr: any = values.reduce(function(r,el,i){
      if(!!el){
        r+=`${keys[i]}=${el}&`
      }
      return r
    },'')
    console.log(arr); 
    const getOne = async()=>{
      const {rows,total} = await getHelpRelation(arr.slice(0,-1));
      rows.forEach((el: any) => {
        el.key = el.id
      });    
      setData(rows)
      setTotal(total)
    }
    getOne()
    setCurrent(1)
  },[])
  const onFinishFailed = useCallback((e: any)=>{
    console.log(e);
  },[])
  const onReset = useCallback(()=>{
    form1.resetFields();
    getAll(1)
  },[form1,getAll])
  const start = useCallback((e: string) => {
    const setOne = async()=>{
      const {code, msg} = await setConfirm({
        // ids: ['3'],
        ids: selectedRowKeys,
        statusEnum: e,
        returnReason: ""
      })
      if(code === 200){
        message.success(`${msg}`);
        getAll(1)
      }else{
        message.error(`${msg}`);
      }
    }
    setOne()
  },[selectedRowKeys,getAll])
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  // console.log('selectedRowKeys changed: ', selectedRowKeys);
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div style={{padding: '15px', background: '#fff'}}>
      <div className='top'>
        <Form
          name="provinceSet"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item
            label="年度"
            name="year"
          >
            <Select
              placeholder="请选择年度"
              onChange={handleChange}
              allowClear
              style={{ width: 80 }}
            >
              <Option value={nowYear}>{nowYear}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="批次"
            name="batchNumber"
          >
            <Select
              placeholder="请选择批次"
              onChange={handleChange}
              allowClear
              style={{ width: 50 }}
            >
              <Option value={batch}>{batch}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="受援医院省份"
            name="recipientInstituteProvince"
          >
            <Select
              placeholder="请选择省份"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {provinceArr.map((e: any,i: number)=>{
                return <Option value={e.value} key={i}>{e.label}</Option>
              })} 
            </Select>
          </Form.Item>

          <Form.Item label="受援医院名称" name="recipientInstituteName" ><Input placeholder="请输入医院名称" style={{ width: 120 }}/></Form.Item>

          <Form.Item
            label="对应学科"
            name="subjectId"
          >
            <Select
              placeholder="请选择学科"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {subjectIdArr.map((e: any,i: number)=>{
                return <Option value={e.id} key={i}>{e.name}</Option>
              })} 
            </Select>
          </Form.Item>

          <Form.Item
            label="确认状态"
            name="confirmStatus"
          >
            <Select
              placeholder="请选择状态"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              <Option value="0">通过</Option>
              <Option value="1">拒绝</Option>
              <Option value="2">未确认</Option>
            </Select>
          </Form.Item>


          <Form.Item style={{marginLeft: '30px'}}>
            <Button className='searchBtn' type="primary" htmlType="submit"><SearchOutlined />查询</Button>
            <Button className='resetBtn' type="primary" onClick={onReset} style={{marginLeft: '15px'}} ><RedoOutlined />重置</Button>
          </Form.Item>
        </Form>
      </div>

      <div className='midBtn'>
        <Button type="primary" onClick={()=>start('0')} disabled={!hasSelected}>通过</Button>
        <Button type="primary" onClick={()=>start('1')} disabled={!hasSelected}>拒绝</Button>
      </div>

      <div>
        <Table size='small' rowSelection={rowSelection} columns={columns} dataSource={data} bordered/>
        {/* <Table size='small' pagination={false} rowSelection={rowSelection} columns={columns} dataSource={data} bordered/>
        <Pagination style={{margin: '10px 0',float: 'right'}} current={current} onChange={onChange} total={total} showSizeChanger={false}/> */}
      </div>
    </div>
  )
}

export default Index